import React, {useEffect, useState} from "react";
import enterpriseObjectClassFactory from "../../eoec/EnterpriseObjectClassFactory";
import EnterpriseObject from "../../eoec/eo/EnterpriseObject";
import EnterpriseComponent from "../../eoec/ec/EnterpriseComponent";
import {prepareBuffer} from "../../util/Buffer";
import EventBus from "../../util/EventBus";
import {Button, Chip, Drawer, IconButton, MenuItem, TextField, Tooltip, Typography} from "@mui/material";
import css_buttons from "../Common/css/CCButton.module.scss";
import css_typography from "../Common/css/Typography.module.scss";
import {Close, Edit, Info} from "@mui/icons-material";
import {Grey5, Grey6} from "../../theme/styles";
import {formatLocalDate} from "../../util/Formatters";
import ProjectPlanPhaseReferenceTableApplet from "../../eoec/applet/impl/ProjectPlan/ProjectPlanPhaseReferenceTableApplet";
import ProjectPlanPhaseFormApplet from "../../eoec/applet/impl/ProjectPlan/ProjectPlanPhaseFormApplet";
import ProjectPlanPhaseAttachmentTableApplet from "../../eoec/applet/impl/ProjectPlan/ProjectPlanPhaseAttachmentTableApplet";
import ProjectPlanPhaseApprovalTableApplet from "../../eoec/applet/impl/ProjectPlan/ProjectPlanPhaseApprovalTableApplet";
import {hasPrivilege, SessionContext, useSessionContext} from "../../util/SessionContext";
import spinner from "../../assets/Spinner-1s-200px.svg";
import CCPulse from "../Common/CCPulse";
import ProjectPlanPhaseSubmitForApproval from "./ProjectPlanPhaseSubmitForApproval";


export default function ProjectPlanPhaseDetail(props: any) {
    const [projectPlanPhaseEnterpriseObject] = useState(enterpriseObjectClassFactory("ProjectPlanPhase") as EnterpriseObject);
    const [projectPlanPhaseBuffer, setProjectPlanPhaseBuffer] = React.useState<Map<string, any>>(new Map<string, any>());
    const [showEditFormForPhase, setShowEditFormForPhase] = React.useState(false);
    const [backgroundOperation, setBackgroundOperation] = useState<boolean>(false);
    const [submitForApprovalButtonStatus, setSubmitForApprovalButtonStatus] = useState<boolean>(false);
    const [showSubmitForApproval, setShowSubmitForApproval] = useState<boolean>(false);
    const [approveButtonStatus, setApproveButtonStatus] = useState<boolean>(false);
    const [submitWithdrawBackgroundOperation, setSubmitWithdrawBackgroundOperation] = useState<boolean>(false);
    const [approveBackgroundOperation, setApproveBackgroundOperation] = useState<boolean>(false);
    const [currentProjectPlanPhaseUSID, setCurrentProjectPlanPhaseUSID] = useState<string>(props.projectPlanPhaseUSID);

    const sessionContext:SessionContext = useSessionContext();

    function enterpriseComponentDeleteCompletedListener(ec: EnterpriseComponent) {
        enterpriseComponentLoadCompletedListener(ec)
    }

    function enterpriseComponentInsertCompletedListener(ec: EnterpriseComponent) {
        enterpriseComponentLoadCompletedListener(ec)
    }

    function enterpriseComponentLoadCompletedListener(ec: EnterpriseComponent) {
        if (ec.getName() === "ProjectPlanPhase") {
            let b: Map<string, any>[] = prepareBuffer(ec)
            setProjectPlanPhaseBuffer(b[0]);
        } else if (ec.getName() === "ProjectPlanPhaseApproval") {
            {
                let status = false;
                if (ec.getEnterpriseObject()?.getEnterpriseComponent("ProjectPlanPhase")?.getAttributeValue("Status") === "DONE") {
                    status = false
                } else if (ec.getBuffer().size > 0 && ec.getBuffer().get(1)!.length > 0) {
                    let counter = 0;
                    for (let i = 0; i < ec.getBuffer().get(1)!.length; i++) {
                        let row = ec.getBuffer().get(1)![i];
                        if (row.get("Status") === "AWAITING SUBMISSION") {
                            counter += 1;
                        }
                    }
                    if (counter === ec.getBuffer().get(1)!.length) {
                        status = true
                    }
                }
                setSubmitForApprovalButtonStatus(status)
            }
            {
                let status = false;
                if (ec.getEnterpriseObject()?.getEnterpriseComponent("ProjectPlanPhase")?.getAttributeValue("Status") === "DONE") {
                    status = false
                } else if (ec.getBuffer().size > 0 && ec.getBuffer().get(1)!.length > 0) {
                    let counter = 0;
                    for (let i = 0; i < ec.getBuffer().get(1)!.length; i++) {
                        let row = ec.getBuffer().get(1)![i];
                        if (row.get("Status") === "AWAITING APPROVAL" && row.get("EmployeeUSID") === sessionContext.getEmployeeUSID()) {
                            counter += 1;
                        }
                    }
                    if (counter > 0) {
                        status = true
                    }
                }
                setApproveButtonStatus(status)
            }
        }
    }

    function enterpriseComponentValueChanged(ec: EnterpriseComponent) {
        let b:Map<string, any>[] = prepareBuffer(ec);
        setProjectPlanPhaseBuffer(b[0]);
    }

    function enterpriseComponentUpdateRollbackCompleted(ec: EnterpriseComponent) {
        let b:Map<string, any>[] = prepareBuffer(ec);
        b = b.slice(ec.getRecordPointer(), ec.getRecordPointer() + 1);
        setProjectPlanPhaseBuffer(b[0]);
    }

    function enterpriseComponentUpdateStarted(ec: EnterpriseComponent) {
        if (ec.getName() === "ProjectPlanPhase") {
            setBackgroundOperation(true);
        } else if (ec.getName() === "ProjectPlanPhaseApproval") {
            setSubmitWithdrawBackgroundOperation(true);
        }
    }

    function enterpriseComponentUpdateCompleted(ec: EnterpriseComponent) {
        if (ec.getName() === "ProjectPlanPhase") {
            let b:Map<string, any>[] = prepareBuffer(ec);
            setProjectPlanPhaseBuffer(b[0]);
            setBackgroundOperation(false);
        } else if (ec.getName() === "ProjectPlanPhaseApproval") {
            setSubmitWithdrawBackgroundOperation(false);
            let projectPlanPhaseEnterpriseComponent: EnterpriseComponent = projectPlanPhaseEnterpriseObject.getEnterpriseComponent("ProjectPlanPhase")!
            projectPlanPhaseEnterpriseComponent.invalidate();
        }
    }

    function enterpriseComponentInvalidateListener(ec: EnterpriseComponent) {
        const projectPlanPhaseEnterpriseComponent: EnterpriseComponent = projectPlanPhaseEnterpriseObject.getEnterpriseComponent("ProjectPlanPhase")!
        projectPlanPhaseEnterpriseComponent.newQuery();
        projectPlanPhaseEnterpriseComponent.setAttributeValue("USID", props.projectPlanPhaseUSID);
        projectPlanPhaseEnterpriseComponent.setIDOCRequest("v1.ProjectPlanPhase-001");
        projectPlanPhaseEnterpriseComponent.setIDOCResponse("v1.ProjectPlanPhase-001");
        projectPlanPhaseEnterpriseComponent.executeQuery(1, 5);
    }

    useEffect(() => {
        const projectPlanPhaseEnterpriseComponent: EnterpriseComponent = projectPlanPhaseEnterpriseObject.getEnterpriseComponent("ProjectPlanPhase")!
        const projectPlanPhaseApprovalEnterpriseComponent: EnterpriseComponent = projectPlanPhaseEnterpriseObject.getEnterpriseComponent("ProjectPlanPhaseApproval")!

        EventBus.components.addListener("project-plan-phase-form-applet-cancel", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-form-applet-save", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-update-save", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-submit-for-approval-cancel", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-submit-for-approval-save", onCancelHandler);

        projectPlanPhaseEnterpriseComponent.newQuery();
        projectPlanPhaseEnterpriseComponent.setAttributeValue("USID", props.projectPlanPhaseUSID);
        projectPlanPhaseEnterpriseComponent.setIDOCRequest("v1.ProjectPlanPhase-001");
        projectPlanPhaseEnterpriseComponent.setIDOCResponse("v1.ProjectPlanPhase-001");
        projectPlanPhaseEnterpriseComponent.executeQuery(1, 5);

        projectPlanPhaseApprovalEnterpriseComponent.addDeleteCompletedListener(enterpriseComponentDeleteCompletedListener);
        projectPlanPhaseApprovalEnterpriseComponent.addInsertCompletedListener(enterpriseComponentInsertCompletedListener);
        projectPlanPhaseApprovalEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        projectPlanPhaseApprovalEnterpriseComponent.addUpdateStartedListener(enterpriseComponentUpdateStarted);
        projectPlanPhaseApprovalEnterpriseComponent.addUpdateCompletedListener(enterpriseComponentUpdateCompleted);
        projectPlanPhaseEnterpriseComponent.addInvalidListener(enterpriseComponentInvalidateListener);
        projectPlanPhaseEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        projectPlanPhaseEnterpriseComponent.addValueChangedListener(enterpriseComponentValueChanged);
        projectPlanPhaseEnterpriseComponent.addUpdateStartedListener(enterpriseComponentUpdateStarted);
        projectPlanPhaseEnterpriseComponent.addUpdateCompletedListener(enterpriseComponentUpdateCompleted);
        projectPlanPhaseEnterpriseComponent.addUpdateRollbackCompletedListener(enterpriseComponentUpdateRollbackCompleted);

        return () => {
            EventBus.components.removeListener("project-plan-phase-form-applet-cancel", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-form-applet-save", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-update-save", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-submit-for-approval-cancel", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-submit-for-approval-save", onCancelHandler);

            projectPlanPhaseApprovalEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener);
            projectPlanPhaseApprovalEnterpriseComponent.removeDeleteCompletedListener(enterpriseComponentDeleteCompletedListener);
            projectPlanPhaseApprovalEnterpriseComponent.removeInsertCompletedListener(enterpriseComponentInsertCompletedListener);
            projectPlanPhaseApprovalEnterpriseComponent.removeUpdateStartedListener(enterpriseComponentUpdateStarted);
            projectPlanPhaseApprovalEnterpriseComponent.removeUpdateCompletedListener(enterpriseComponentUpdateCompleted);
            projectPlanPhaseEnterpriseComponent.removeInvalidListener(enterpriseComponentInvalidateListener);
            projectPlanPhaseEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener);
            projectPlanPhaseEnterpriseComponent.removeValueChangedListener(enterpriseComponentValueChanged);
            projectPlanPhaseEnterpriseComponent.removeUpdateStartedListener(enterpriseComponentUpdateStarted);
            projectPlanPhaseEnterpriseComponent.removeUpdateCompletedListener(enterpriseComponentUpdateCompleted);
            projectPlanPhaseEnterpriseComponent.removeUpdateRollbackCompletedListener(enterpriseComponentUpdateRollbackCompleted);
        }

    }, [projectPlanPhaseEnterpriseObject, props.projectPlanPhaseUSID]);

    function onCancelHandler() {
        setShowEditFormForPhase(false)
        setShowSubmitForApproval(false)
    }

    function setPhaseSelector(value: string) {
        const projectPlanPhaseEnterpriseComponent: EnterpriseComponent = projectPlanPhaseEnterpriseObject.getEnterpriseComponent("ProjectPlanPhase")!
        projectPlanPhaseEnterpriseComponent.newQuery();
        projectPlanPhaseEnterpriseComponent.setAttributeValue("USID", value);
        projectPlanPhaseEnterpriseComponent.executeQuery(1, 5);

        setCurrentProjectPlanPhaseUSID(value)
    }

    function reopenPhase() {
        const projectPlanPhaseEnterpriseComponent: EnterpriseComponent = projectPlanPhaseEnterpriseObject.getEnterpriseComponent("ProjectPlanPhase")!

        projectPlanPhaseEnterpriseComponent.setAttributeValue("Status", "IN PROGRESS");
        projectPlanPhaseEnterpriseComponent.executeUpdate();
    }

    function hasPhaseEditPrivilege() {
        if (projectPlanPhaseBuffer.get("Status") === "DONE") {
            return hasPrivilege("Edit Phase") && hasPrivilege("Edit Done Phase");
        } else {
            return hasPrivilege("Edit Phase");
        }
    }

    function submitForApproval() {
        const projectPlanPhaseEnterpriseComponent: EnterpriseComponent = projectPlanPhaseEnterpriseObject.getEnterpriseComponent("ProjectPlanPhase")!
        if (projectPlanPhaseEnterpriseComponent.getAttributeValue("NumberOfMilestonesInInProgressStatus") > 0) {
            setShowSubmitForApproval(!showSubmitForApproval)
        } else {
            const projectPlanPhaseApprovalEnterpriseComponent: EnterpriseComponent = projectPlanPhaseEnterpriseObject.getEnterpriseComponent("ProjectPlanPhaseApproval")!
            projectPlanPhaseApprovalEnterpriseComponent.setAttributeValue("Submit", true)
            projectPlanPhaseApprovalEnterpriseComponent.executeUpdate();
        }
    }

    function withdraw() {
        const projectPlanPhaseApprovalEnterpriseComponent: EnterpriseComponent = projectPlanPhaseEnterpriseObject.getEnterpriseComponent("ProjectPlanPhaseApproval")!
        projectPlanPhaseApprovalEnterpriseComponent.setAttributeValue("Withdraw", true)
        projectPlanPhaseApprovalEnterpriseComponent.executeUpdate();
    }

    return (
        <>
            {showEditFormForPhase ? <ProjectPlanPhaseFormApplet enterpriseComponent={projectPlanPhaseEnterpriseObject.getEnterpriseComponent("ProjectPlanPhase")} defaultAction={"Edit"}/> : null}
            {showSubmitForApproval ? <ProjectPlanPhaseSubmitForApproval enterpriseComponent={projectPlanPhaseEnterpriseObject.getEnterpriseComponent("ProjectPlanPhase")}/> : null}
            <Drawer anchor={"right"} open={true}>
                <div style={{width: "1050px"}}>
                    <div style={{display: "flex", flexDirection: "column", margin: "20px 20px 20px 20px"}}>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: "40px"}}>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                                <div style={{width: "275px"}}>
                                    <TextField select={true}
                                               fullWidth={true}
                                               size="small"
                                               label={"Phase"}
                                               value={currentProjectPlanPhaseUSID}
                                               onChange={(e) => setPhaseSelector(e.target.value)}
                                               variant="outlined"
                                               slotProps={{
                                                   input: {

                                                   },
                                                   inputLabel: {
                                                       shrink: true
                                                   }
                                               }}>
                                        {props.projectPlanBuffer.get("ProjectPlanPhases").map((phase: any, i: number) => (
                                            <MenuItem value={phase["USID"]}>{phase["Name"]}</MenuItem>
                                        ))}

                                    </TextField>
                                </div>
                            </div>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
                                <IconButton className={css_buttons.blueIconButton} style={{marginLeft: "5px"}} onClick={() => {
                                    EventBus.components.emit("project-plan-phase-panel-close");
                                }}>
                                    <Close sx={{color: Grey5, width: "35px", height: "35px"}}/>
                                </IconButton>
                            </div>
                        </div>

                        <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: "60px"}}>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: "20px"}}>
                                <Typography style={{fontSize: "24px", fontWeight: 600, color: "#000000"}}>Phase:&nbsp;</Typography>
                                <Typography style={{fontSize: "24px", fontWeight: "600", color: "#A8A9AF", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap"}}>&nbsp;{projectPlanPhaseBuffer.get("Name")}</Typography>
                                <div style={{paddingLeft: "15px", paddingTop: "3px", paddingRight: "7px"}}>
                                    <Chip label={projectPlanPhaseBuffer.get("Status")} size="small" style={{border: "1px solid #B26000", fontSize: 12, marginTop: "3px", backgroundColor: "#FEF8EE", color: "#B26000"}}/>
                                </div>
                                {projectPlanPhaseBuffer.get("Status") === "DONE" && hasPhaseEditPrivilege() ? (
                                    <div style={{marginLeft: "10px", marginTop: "-2px"}}>
                                        <Button className={css_buttons.blueStandardButton} onClick={() => {
                                            reopenPhase()
                                        }}>
                                            <Typography style={{fontSize: "16px"}}>Reopen Phase</Typography>
                                        </Button>
                                    </div>
                                ) : (
                                    <>
                                        <div>
                                            <Tooltip title={"Edit Phase"}>
                                                <IconButton className={css_buttons.blueIconButton} disabled={!hasPhaseEditPrivilege()} onClick={() => {
                                                    setShowEditFormForPhase(true);
                                                }}>
                                                    <Edit sx={{width: "20px", height: "20px", marginTop: "0px"}}/>
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                        {!hasPhaseEditPrivilege() ? (
                                            <div style={{marginTop: "6px"}}>
                                                <Tooltip title={projectPlanPhaseBuffer.get("Status") === "DONE" ? "This feature is disabled because you do not have the 'Edit Phase' privilege. In addition, since the phase is DONE, you will also need the 'Edit Done Phase' privilege." : "This feature is disabled because you do not have the 'Edit Phase' privilege in any of your assigned roles."}>
                                                    <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                                </Tooltip>
                                            </div>
                                        ) : null}
                                    </>
                                )}
                                {backgroundOperation ? (
                                    <div style={{marginLeft: "10px", marginTop: "-10px"}}>
                                        <img src={spinner} alt="Spinner" style={{width: "55px", height: "55px"}} />
                                    </div>
                                ) : null}
                            </div>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
                                {submitForApprovalButtonStatus ? (
                                    <div style={{marginLeft: "10px", marginTop: "19px"}}>
                                        <Button style={{width: "200px"}} className={css_buttons.blueStandardButton} onClick={(e: any) => {
                                            e.preventDefault();
                                            submitForApproval()
                                        }}>
                                            {!submitWithdrawBackgroundOperation ? <Typography style={{fontSize: "16px"}}>Submit for Approval</Typography> : null}
                                            {submitWithdrawBackgroundOperation ? <CCPulse className={css_buttons.Pulse} DotProps={undefined} /> : undefined}
                                        </Button>
                                    </div>
                                ) : null}
                                {projectPlanPhaseBuffer.get("Status") === "IN REVIEW" && approveButtonStatus ? (
                                    <div style={{marginLeft: "10px", marginTop: "19px"}}>
                                        <Button style={{width: "175px"}} className={css_buttons.blueStandardButton} onClick={(e: any) => {
                                            e.preventDefault();
                                            // approve()
                                        }}>
                                            {!approveBackgroundOperation ? <Typography style={{fontSize: "16px"}}>Approve</Typography> : null}
                                            {approveBackgroundOperation ? <CCPulse className={css_buttons.Pulse} DotProps={undefined} /> : undefined}
                                        </Button>
                                    </div>
                                ) : null}
                                {projectPlanPhaseBuffer.get("Status") === "IN REVIEW" ? (
                                    <div style={{marginLeft: "10px", marginTop: "19px"}}>
                                        <Button style={{width: "175px"}} className={css_buttons.blueStandardButton} onClick={(e: any) => {
                                            e.preventDefault();
                                            withdraw()
                                        }}>
                                            {!submitWithdrawBackgroundOperation ? <Typography style={{fontSize: "16px"}}>Withdraw</Typography> : null}
                                            {submitWithdrawBackgroundOperation ? <CCPulse className={css_buttons.Pulse} DotProps={undefined} /> : undefined}
                                        </Button>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: "10px"}}>
                            <Typography style={{fontSize: 17, fontWeight: 400, color: Grey6}}>{projectPlanPhaseBuffer.get("Description")}</Typography>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: "10px", borderBottom: "2px solid #EDEFF3"}}/>
                        <div style={{width: "100%", padding: "10px"}}>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "40px", width: "100%"}}>
                                <div style={{width: "100px"}}>
                                    <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>Name:</Typography>
                                </div>
                                <div style={{width: "400px"}}>
                                    <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{projectPlanPhaseBuffer.get("Name") ?? "--"}</Typography>
                                </div>
                            </div>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "40px", width: "100%"}}>
                                <div style={{width: "100px"}}>
                                    <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>Start Date:</Typography>
                                </div>
                                <div style={{width: "400px"}}>
                                    <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{formatLocalDate(projectPlanPhaseBuffer.get("StartDatetime")) ?? "--"}</Typography>
                                </div>
                            </div>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "40px", width: "100%"}}>
                                <div style={{width: "100px"}}>
                                    <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>Due Date:</Typography>
                                </div>
                                <div style={{width: "400px"}}>
                                    <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{formatLocalDate(projectPlanPhaseBuffer.get("DueDatetime")) ?? "--"}</Typography>
                                </div>
                            </div>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "40px", width: "100%"}}>
                                <div style={{width: "100px"}}>
                                    <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>Notes:</Typography>
                                </div>
                                <div style={{width: "400px"}}>
                                    <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{projectPlanPhaseBuffer.get("Notes") ?? "--"}</Typography>
                                </div>
                            </div>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "40px", width: "100%"}}>
                                <div style={{width: "100px"}}>
                                    <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>Justification:</Typography>
                                </div>
                                <div style={{width: "400px"}}>
                                    <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{projectPlanPhaseBuffer.get("Justification") ?? "--"}</Typography>
                                </div>
                            </div>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: "20px"}}>
                            <ProjectPlanPhaseReferenceTableApplet enterpriseComponent={projectPlanPhaseEnterpriseObject.getEnterpriseComponent("ProjectPlanPhaseReference")!}/>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: "30px"}}>
                            <ProjectPlanPhaseAttachmentTableApplet enterpriseComponent={projectPlanPhaseEnterpriseObject.getEnterpriseComponent("ProjectPlanPhaseAttachment")!}/>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: "30px"}}>
                            <ProjectPlanPhaseApprovalTableApplet enterpriseComponent={projectPlanPhaseEnterpriseObject.getEnterpriseComponent("ProjectPlanPhaseApproval")!}/>
                        </div>
                    </div>
                </div>
            </Drawer>
        </>
    )
}
